export const timeFrames = {
    'm': {
        title: 'M1',
        inMin: 1,
        startOf: 'minute',
    },
    '5m': {
        title: 'M5',
        inMin: 5,
        startOf: 'hour',
    },
    '15m': {
        title: 'M15',
        inMin: 15,
        startOf: 'hour',
    },
    '30m': {
        title: 'M30',
        inMin: 30,
        startOf: 'hour',
    },
    'h': {
        title: 'H1',
        inMin: 60,
        startOf: 'hour',
    },
    '4h': {
        title: 'H4',
        inMin: 60 * 4,
        startOf: 'day',
    },
    'd': {
        title: 'D1',
        inMin: 24 * 60,
        startOf: 'day',
    },
    'w': {
        title: 'W1',
        inMin: 7 * 24 * 60,
        startOf: 'month',
    },
    // 'mo': {
    //     title: 'MO',
    //     inMin: 30 * 24 * 60,
    //     startOf: 'month',
    // },
}

export const defaultChartCanvasProps = {
    height: 300,
    seriesName: 'Data',
    clamp: false,
    defaultFocus: true,
    disablePan: false,
    disableInteraction: false,
    disableZoom: true, // Если включить, на андроиде вылетает с ошибкой если начать двумя пальцами зумить
    flipXScale: false,
    padding: 0,
}

export const defaultChartXAxisProps = {
    showGridLines: true,
    fontFamily: 'OpenSans',
    fontSize: 12,
    gridLinesStrokeDasharray: 'Dot',
    gridLinesStrokeStyle: '#262840',
    gridLinesStrokeWidth: 1,
    strokeStyle: 'transparent',
    tickLabelFill: 'rgba(255,255,255,0.6)',
    tickStrokeStyle: '#262840',
    zoomEnabled: false,
}

export const defaultChartYAxisProps = {
    showGridLines: true,
    fontFamily: 'OpenSans',
    fontSize: 12,
    gridLinesStrokeDasharray: 'Dot',
    gridLinesStrokeStyle: '#262840',
    gridLinesStrokeWidth: 1,
    strokeStyle: 'transparent',
    tickLabelFill: 'rgba(255,255,255,0.6)',
    tickPadding: 0,
    ticks: 4,
    tickStrokeStyle: '#262840',
    type: 'Dot',
    zoomEnabled: false,
}

export const defaultChartEdgeIndicatorProps = {
    fill: 'rgba(55, 55, 55, 1)',
    fitToText: true,
    fontFamily: 'OpenSans',
    fontSize: 12,
    fullWidth: true,
    itemType: 'last',
    lineStroke: 'rgba(255,255,255,0.3)',
    orient: 'right',
    rectWidth: 0,
    stroke: 'transparent',
    yAxisPad: 0,
}
